import qrcode from 'qrcode-generator';
import { metric } from '../api';
import { L, config } from '../state';
import { escapeHtml, show } from '../ui/modal';

/**
 * Genera el QR en el propio navegador a partir de la URL de reseñas.
 *
 * El V24 dependía de una imagen subida a mano (`google_review_qr`), que además
 * la CSP bloqueaba si era externa. Así el operador sólo configura la URL en
 * Fleet Control y el código se dibuja como SVG: nítido a cualquier tamaño.
 */
function buildQrSvg(url: string): string | null {
  try {
    // Corrección de errores alta: el QR sigue leyéndose con reflejos o suciedad.
    const qr = qrcode(0, 'H');
    qr.addData(url);
    qr.make();
    return qr.createSvgTag({ cellSize: 8, margin: 2, scalable: true });
  } catch {
    return null;
  }
}

function isSafeUrl(value: string): boolean {
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

export function reviews(): void {
  void metric('reviews_open');
  const lang = L();
  const url = String(config.googleReviewUrl ?? '').trim();
  const legacyQr = String(config.googleReviewQr ?? '').trim();

  let visual: string;
  let actions = '';

  if (url && isSafeUrl(url)) {
    const svg = buildQrSvg(url);
    visual = svg
      ? `<div class="qr-img">${svg}</div>`
      : `<p class="fineprint">No se pudo generar el código QR.</p>`;
    actions = `
      <div class="qr-actions">
        <a class="cta" id="reviewLink" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">
          ${escapeHtml(lang.reviews)}
        </a>
      </div>
      <p class="qr-url">${escapeHtml(url)}</p>`;
  } else if (legacyQr) {
    visual = `<img class="qr-img" src="${escapeHtml(legacyQr)}" alt="QR Google Review">`;
  } else {
    visual = `<p class="fineprint">Las reseñas todavía no están configuradas para este operador.
      Añade la URL en Fleet Control → Ajustes → <b>Enlace de reseñas de Google</b>.</p>`;
  }

  show(lang.reviews, `
    <div class="qr-wrap">
      <p>${escapeHtml(lang.reviewText)}</p>
      ${visual}
      ${actions}
      <div class="review-note">📱 ${escapeHtml(lang.extra.note)}</div>
    </div>`);

  document.querySelector('#reviewLink')?.addEventListener('click', () => void metric('source_open'));
}
